
import React from "react";

import UiTabbedForm from './UiTabbedForm';
import UiCustomForm from './UiCustomForm';
import UiInlineForm from './UiInlineForm';
import UiExpandForm from './UiExpandForm';
import UiAccordionForm from './UiAccordionForm';
import UiSimpleForm from './UiSimpleForm';


export const formMap = (form_name, resourcesFields, resourcesTabs, canDelete, tabs,id,resourcePermistions) => {

    var component = '';
  
  
    switch (form_name) {
      case "UiCustomForm":
        component = <UiCustomForm resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id} tabs={tabs} />
        break;
      case "UiAccordionForm":
        component = <UiAccordionForm resourcePermistions={resourcePermistions} resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id}  tabs={tabs} />
        break;
        case "UiSimpleForm":
          component = <UiSimpleForm resourcePermistions={resourcePermistions} resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete}  id={id}  tabs={tabs} />
          break;
        
        case "UiTabbedForm":
          component = <UiTabbedForm resourcePermistions={resourcePermistions} resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id}  tabs={tabs} />
          break;
        case "UiInlineForm":
          component = <UiInlineForm resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id}  tabs={tabs} />
          break;
          case "UiExpandForm":
            component = <UiExpandForm resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id}  tabs={tabs} />
            break;
          

        
      default:
        component = <UiTabbedForm resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete}  id={id}  tabs={tabs} />
    }
    return component;
  };


  export const formMapCreate = (initValues,form_name, resourcesFields, resourcesTabs, canDelete, tabs,id,resourcePermistions) => {
    

    var component = '';
  
  
    switch (form_name) {
      case "UiCustomForm":
        component = <UiCustomForm resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id} tabs={tabs} />
        break;
      case "UiAccordionForm":
        component = <UiAccordionForm resourcePermistions={resourcePermistions} resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id}  tabs={tabs} />
        break;
        case "UiSimpleForm":
          component = <UiSimpleForm  resourcePermistions={resourcePermistions} resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} initValues={initValues} id={id}  tabs={tabs} />
          break;
        
        case "UiTabbedForm":
          component = <UiTabbedForm resourcePermistions={resourcePermistions} resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id}  tabs={tabs} />
          break;
        case "UiInlineForm":
          component = <UiInlineForm resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id}  tabs={tabs} />
          break;
          case "UiExpandForm":
            component = <UiExpandForm resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete} id={id}  tabs={tabs} />
            break;
          

        
      default:
        component = <UiTabbedForm resourcesFields={resourcesFields} resourcesTabs={resourcesTabs} canDelete={canDelete}  id={id}  tabs={tabs} />
    }
    return component;
  };


  export default formMap;